import actionTypes from 'dashboard/actions/eft-history/action-types';

export default (state = null, action) => {
  switch (action.type) {
    case actionTypes.FETCH_RETAILER_EFT_DETAIL_DATE_SUCCESS:
      return action.date;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/eft-history/date.js